import { apiSlice } from "../api/apiSlice";

export const productsApi = apiSlice.injectEndpoints({
  tagTypes: ["SingleProductGet", "AllReviews", "SingleReview"],
  endpoints: (builder) => ({
    //get all products
    getAllProducts: builder.query({
      query: () => ({
        url: `/product`,
      }),
    }),
    //get all products
    getAllProductsByCategory: builder.query({
      query: (id) => ({
        url: `/product/category/${id}`,
      }),
    }),

    //get single product
    getSingleProduct: builder.query({
      query: (id) => ({
        url: `/product/${id}`,
      }),
      providesTags: ["SingleProductGet"],
    }),

    //get new arrivals product
    getNewArrivals: builder.query({
      query: () => ({
        url: `/product/productType/new-arrivals`,
      }),
    }),
    //get featured product
    getFeaturedProducts: builder.query({
      query: () => ({
        url: `/product/productType/featured-products`,
      }),
    }),
    //get new arrivals product
    getRegularProducts: builder.query({
      query: () => ({
        url: `/product/productType/regular-products`,
      }),
    }),
    //get new arrivals product
    getPopularProducts: builder.query({
      query: () => ({
        url: `/product/productType/popular-products`,
      }),
    }),

    // review api
    //get all reviews
    getAllReviews: builder.query({
      query: () => ({
        url: `/review`,
      }),
      providesTags: ["AllReviews"],
    }),

    //get all reviews BY EMAIL
    getAllReviewsByEmail: builder.query({
      query: (userEmail) => ({
        url: `/review/${userEmail}`,
      }),
      providesTags: ["SingleReview"],
    }),

    //add a  reviews
    addSingleReview: builder.mutation({
      query: ({ data, userEmail }) => ({
        url: `/review/${userEmail}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["AllReviews", "SingleProductGet", "SingleReview"],
    }),
  }),
});

export const {
  useGetAllProductsQuery,
  useGetAllProductsByCategoryQuery,
  useGetSingleProductQuery,
  useGetNewArrivalsQuery,
  useGetFeaturedProductsQuery,
  useGetRegularProductsQuery,
  useGetPopularProductsQuery,
  useGetAllReviewsQuery,
  useGetAllReviewsByEmailQuery,
  useAddSingleReviewMutation,
} = productsApi;
